export const deviceType = {
  speeding: 1,
  vehicle: 2,
  cyclist: 3,
  radar: 4,
  hiker: 5,
};
